import Api from '../../common/api';

const api = Api.getApi();

export async function requestLoginApi(data) {
  const api = Api.getAPiOsTicket();
  const response = await api.request('post', '/outbound/api/authen/login', data);
  const { user, ...rest } = response;
  return { user, metadata: { ...rest } };
}

export async function requestRequestResetPasswordApi(data) {
  const api = Api.getAPiOsTicket();
  const response = await api.request('post', '/outbound/api/authen/reset-password', data);
  const { user, ...rest } = response;
  return { user, metadata: { ...rest } };
}

export async function requestResetPasswordApi(data) {
  const api = Api.getAPiOsTicket();
  const response = await api.request('post', '/outbound/api/authen/update-password', data);
  const { user, ...rest } = response;
  return { user, metadata: { ...rest } };
}

export async function requestLogoutApi(data) {
  const api = Api.getAPiOsTicket();
  const response = await api.request('post', '/outbound/api/authen/logout', data);
  return response;
}

export async function requestTokenApi({ queryString, ssoUrl }) {
  const response = await api.request('post', '/oauth2/token', queryString, {
    baseURL: ssoUrl,
  });
  return response;
}

export async function requestRefreshTokenApi({ queryString, ssoUrl }) {
  const response = await api.request('post', '/oauth2/token', queryString, {
    baseURL: ssoUrl,
    transformRequest: [
      (data, headers) => {
        delete headers.Authorization;
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        return data;
      },
    ],
  });
  return response;
}
